module.exports = __webpack_public_path__ + "static/img/case4_2.jpeg";